/**
 * Convert seconds to rounded amount of minutes
 * 65 input becomes 1
 * 90 input becomes 2
 */
export const formatScondsToRoundedMinutes = (inputSeconds: number) => {
    const formattedSeconds = parseInt(inputSeconds.toFixed(), 10);
    const minutes = Math.floor(formattedSeconds / 60);
    const seconds = formattedSeconds - minutes * 60;

    return seconds >= 30 ? minutes + 1 : minutes;
};
